import { useAppSelector } from '@/Hooks/useAppRedux';
import { Modal, Switch } from 'antd';
import React, { useEffect, useState } from 'react'

interface IProps {
  open: boolean,
  userUuid: string
  closeModal: () => void,
  onConfirmClick: (userUuid: string, interest: number[]) => void
}

const UserInterest = ({
  open,
  userUuid,
  closeModal,
  onConfirmClick
}: IProps) => {
  const { accountsInterest, topics } = useAppSelector((state) => state.accountsInterest)
  const [localUserInterest, setLocalUserInterest] = useState<number[]>([]);

  const onInterestChange = (id: number) => {
    const tempList = [...localUserInterest];
    if (tempList.includes(id)){
      tempList.splice(tempList.indexOf(id),1)
    } else {
      tempList.push(id)
    }
    setLocalUserInterest(tempList);
  }

  useEffect(() => {
    const user = accountsInterest.data.find((accounts) => accounts.uuid === userUuid)
    if (user !== undefined){
      setLocalUserInterest(user.interests)
    }
    
  }, [accountsInterest, accountsInterest.data, userUuid])

  return (
    <Modal
      open={open}
      destroyOnClose
      onOk={() => onConfirmClick(userUuid, localUserInterest)}
      onCancel={() => closeModal()}
      title="Please select/deselect topics"
    >
      <div className="flex flex-col gap-4">
        {topics.map((topic) => (
          <div className='flex flex-row justify-between'>
            <div className='h-6 line-clamp-1 break-all m-0'>{topic.name}</div>
            <Switch 
              checked={localUserInterest.includes(topic.id)}
              onChange={() => onInterestChange(topic.id)}
            />            
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default UserInterest;